const devLoggerPlugin = store => {
  if (process.env.NODE_ENV !== 'development') return
  store.subscribe((_mutation, _state) => {
    // Vuex mutation logger disabled
  })
}

export default devLoggerPlugin
